import { Grid, Box, Stack, styled } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { IHarvestBotCustomize, startHarvestBots } from 'wisestep-api';
import { WsColors, Button, WsDrawer, WsTypography, WsTypoColors } from 'wisestep-base';

import { useSKUModalStore } from '../../../../components/skuModal/SKUModalStore';
import { failed, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { AppLayoutTheme } from '../../../candidates/utils/CandidateHelper';
import { toLowerCaseWithFirstLetterCapital } from '../../utils/nativeSearchHelper';
import {
  profiles,
  downloadSettings,
  sourceAfter,
  timeTypeDropDownOptions,
  stopAfter,
  notifyVia,
  setAdditionalFieldOnRequest,
} from '../BotsHelper';

import BotCustomizationForm from './BotCustomizationForm';

const BotCustomization = ({
  name,
  request,
  accountId,
  setOpenSourceBotBool,
  setShowConfigPanelBool,
  openSourceBot = false,
  showConfigPanel = true,
  jobBoardName,
  queryError,
}) => {
  const setNotification = useNotificationStore((state) => state.setNotification);

  const harvestBotCustom: IHarvestBotCustomize = {
    name: `Sourcing bot for ${name}`,
    sortBy: profiles[jobBoardName]?.[0].value ?? 'activityDate',
    autoDownload: downloadSettings[1].value,
    harvestingInterval: sourceAfter[0].value,
    intervalUnit: 1,
    intervalType: timeTypeDropDownOptions[0].value,
    downloadLimit: 10,
    stopAfter: stopAfter[0].value,
    notification: notifyVia[2].value,
    stopAfterUnit: 1,
    stopAfterType: timeTypeDropDownOptions[0].value,
    enableEmail: true,
    search: request ? JSON.stringify(request) : '',
    jobBoardAccountId: accountId,
  };
  const setModal = useSKUModalStore((state) => state.setModal);

  const startHarvestBot = async (data, isCustom: boolean) => {
    harvestBotCustom.name = data.name ?? harvestBotCustom.name;
    harvestBotCustom.sortBy = data.sortBy ?? 'activityDate';
    harvestBotCustom.autoDownload = data.autoDownload ?? false;
    harvestBotCustom.stopAfterUnit = data.stopAfterUnit ?? 1;
    harvestBotCustom.harvestingInterval = data.harvestingInterval ?? '1H';
    harvestBotCustom.intervalType = data.intervalType ?? 'HOUR';
    harvestBotCustom.stopAfterType = data.stopAfterType ?? 'HOUR';
    if (isCustom) {
      harvestBotCustom.harvestingInterval = data.harvestingInterval ?? '1H';
      if (data.stopAfter == 'CUSTOM') harvestBotCustom.stopAfter = data.stopAfter;
      else
        harvestBotCustom.stopAfter =
          data.stopAfterType == 'DAY' ? `${data.stopAfter}D` : `${data.stopAfter ?? 6}H` ?? '1D';
    } else {
      harvestBotCustom.harvestingInterval = '1H';
      data.stopAfter = 'CUSTOM';
      data.stopAfterUnit = 8;
    }
    harvestBotCustom.downloadCriteria = JSON.stringify({ skills: data.skills });
    setOpenSourceBotBool(false);
    try {
      await startHarvestBots(setAdditionalFieldOnRequest(harvestBotCustom));
      setNotification(success(`Your sourcing bot ${harvestBotCustom.name} name has been created.`));
    } catch (error: any) {
      if (error.response.status == 402) {
        setModal({ object: error.response.data, type: 'count' });
      }
    }
    setShowConfigPanelBool(false);
  };
  const BotButtonTheme = styled(Button)(() => ({
    marginLeft: 3,
    background: WsColors.White,
    color: WsColors.TheBlues500,
  }));
  return (
    <>
      {showConfigPanel && (
        <AppLayoutTheme>
          <Box p={1}>
            <Stack direction="row">
              <Grid item xs={6} container style={{ margin: 'auto' }}>
                <WsTypography bold={true} color={WsTypoColors.WHITE}>
                  {`Search ${toLowerCaseWithFirstLetterCapital(
                    jobBoardName
                  )} automatically with these keywords every hour for 8 hours`}
                </WsTypography>
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Stack direction="row" spacing={2}>
                  <BotButtonTheme
                    variant="contained"
                    size="small"
                    onClick={() => {
                      !isEmpty(queryError)
                        ? startHarvestBot(harvestBotCustom, false)
                        : setNotification(failed('Search Query is Required'));
                    }}
                  >
                    Yes
                  </BotButtonTheme>
                  <BotButtonTheme
                    variant="contained"
                    size="small"
                    onClick={() => setShowConfigPanelBool(false)}
                  >
                    No
                  </BotButtonTheme>
                  <BotButtonTheme
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setShowConfigPanelBool(false);
                      setOpenSourceBotBool(true);
                    }}
                  >
                    Customize
                  </BotButtonTheme>
                </Stack>
              </Grid>
            </Stack>
          </Box>
        </AppLayoutTheme>
      )}
      <WsDrawer
        size="small"
        title={'Setup a Sourcing Bots'}
        iconType="cross"
        open={openSourceBot}
        onClose={() => setOpenSourceBotBool(false)}
      >
        <BotCustomizationForm
          defaultValuesObj={harvestBotCustom}
          onClose={setOpenSourceBotBool}
          onSubmit={(d) => startHarvestBot(d, true)}
        />
      </WsDrawer>
    </>
  );
};

export default BotCustomization;
